import { Link } from "react-router-dom";
import { Accordion } from "../../../../ui_elements";
import styles from "../styles.module.css";

export const Diploma = ({ handleCurrentLink, applicationForms }) => {
	return (
		<>
			<Accordion defaultState={true} title={"Diploma"}>
				<p className="text-left mt-3">
					Please select a link applicable to you from the list below
				</p>
				<div className={`${styles.cardLinks} mt-2`}>
					<Link
						to={() => handleCurrentLink(applicationForms.DIPLOMA)}
					>
						Generate Invoice
					</Link>
					<Link to="/diploma_login">Application Form</Link>
				</div>
			</Accordion>
		</>
	);
};
